import { render } from "./ContactNE.vue?vue&type=template&id=49163aa9&scoped=true"
import script from "./ContactNE.vue?vue&type=script&lang=js"
export * from "./ContactNE.vue?vue&type=script&lang=js"

import "98.css?vue&type=style&index=0&lang=css"
import "./ContactNE.vue?vue&type=style&index=1&id=49163aa9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/oliverclark15.github.io.source/oliverclark15.github.io.source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49163aa9"]])

export default __exports__